import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "currency-list" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "currency-item__img" }
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = { class: "currency-short" }
const _hoisted_6 = { class: "currency-name" }

import { computed } from "vue";
  import { useAuctionStore } from "@/stores/AuctionStore";

  
export default /*#__PURE__*/_defineComponent({
  __name: 'CurrencyList',
  setup(__props) {

  const auctionStore = useAuctionStore();
  const currency = computed(() => auctionStore.currency);
  const currencies = computed(() => auctionStore.currencies);

  const setCurrency = (value: string) => {
    const selectedCurrency = currencies.value.find(item => item.abbr === value);
    auctionStore.$patch({
      currency: value,
      isCurrencyBase: selectedCurrency?.is_base
    });
  };

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currencies.value, (currency) => {
      return (_openBlock(), _createElementBlock("div", {
        key: currency.abbr,
        class: "currency-item",
        onClick: ($event: any) => (setCurrency(currency.abbr))
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("img", {
            class: "img",
            src: currency.flag_image,
            alt: currency.abbr
          }, null, 8, _hoisted_4)
        ]),
        _createElementVNode("div", _hoisted_5, _toDisplayString(currency.abbr), 1),
        _createElementVNode("div", _hoisted_6, _toDisplayString(currency.name), 1)
      ], 8, _hoisted_2))
    }), 128))
  ]))
}
}

})